import { useCallback, type FC, type ReactElement, type ReactNode } from 'react';

import { getSelectedInstance } from '@localstack/services';

import { AppInspectorContextProvider } from '@localstack/appinspector-ui';
import { Link } from 'react-router-dom';
import { PATH_PREFIX_APPINSPECTOR } from '@localstack/constants';

import type { InstanceViewProps } from '../props';

const ContextProvider: FC<{ children: ReactNode }> = (props) => {
  const instance = getSelectedInstance();
  if (!instance) {
    throw new Error('Expected instance to be defined. See getSelectedInstance.');
  }

  return (
    <AppInspectorContextProvider
      localstackEndpoint={instance.endpoint}
      linkComponent={useCallback(
        ({ to, children }) => (
          <Link to={to}>{children}</Link>
        ),
        [],
      )}
      routePrefix={PATH_PREFIX_APPINSPECTOR.replace(':iid', instance.id)}
      spansWorkerUrl={process.env.REACT_APP_APPINSPECTOR_SPANS_WORKER_URL}
    >
      {props.children}
    </AppInspectorContextProvider>
  );
};

export const wrapAppInspectorPage = (Page: FC): ((props: InstanceViewProps) => ReactElement) => {
  return function StudioPageWrapper({ Layout }) {
    return (
      <Layout maxWidth="xl" title="App Inspector" flushContent>
        <ContextProvider>
          <Page />
        </ContextProvider>
      </Layout>
    );
  };
};
